import { render } from "./RbTextArea.vue?vue&type=template&id=1739d780&scoped=true"
import script from "./RbTextArea.vue?vue&type=script&lang=js"
export * from "./RbTextArea.vue?vue&type=script&lang=js"

import "./RbTextArea.vue?vue&type=style&index=0&id=1739d780&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1739d780"]])

export default __exports__